import { z } from 'zod';
import { ADJUST_FIELDS } from './adjust-fields.js';
import { INVENTORY_ADJUST_CONSTRAINTS as LIMITS } from './constraints.js';
/**
 * No reason here: the counter reports the shelf, and a change they cannot account for opens a
 * variance that someone closes later with a cause. `note` stays, for what they saw at the bin.
 */
const countedRowSchema = z.object({
    tagId: ADJUST_FIELDS.id('Stock'),
    countedQuantity: ADJUST_FIELDS.countedQuantity(),
    expectedAvailable: ADJUST_FIELDS.countedQuantity(),
    note: ADJUST_FIELDS.note(),
});
const foundRowSchema = z.object({
    partId: ADJUST_FIELDS.id('Part'),
    brandId: ADJUST_FIELDS.id('Brand'),
    locationId: ADJUST_FIELDS.id('Location'),
    lotNumber: ADJUST_FIELDS.lotNumber(),
    countedQuantity: ADJUST_FIELDS.quantity(),
    unitCost: ADJUST_FIELDS.unitCost(),
    note: ADJUST_FIELDS.note(),
    confirmedLotWarning: z.boolean().optional(),
});
const tooMany = `${LIMITS.countRows.label}: a count holds at most ${LIMITS.countRows.max} rows.`;
export const postInventoryCountInputSchema = z
    .object({
    requestId: ADJUST_FIELDS.requestId(),
    rows: z.array(countedRowSchema).max(LIMITS.countRows.max, tooMany).default([]),
    foundRows: z.array(foundRowSchema).max(LIMITS.countRows.max, tooMany).default([]),
})
    .superRefine((value, context) => {
    if (value.rows.length + value.foundRows.length === 0) {
        context.addIssue({ code: 'custom', message: 'Count at least one row.', path: ['rows'] });
    }
    if (value.rows.length + value.foundRows.length > LIMITS.countRows.max) {
        context.addIssue({ code: 'custom', message: tooMany, path: ['rows'] });
    }
    const seen = new Set();
    value.rows.forEach((row, index) => {
        if (seen.has(row.tagId.toLowerCase())) {
            context.addIssue({
                code: 'custom',
                message: 'This stock is already in the count.',
                path: ['rows', index, 'tagId'],
            });
        }
        seen.add(row.tagId.toLowerCase());
    });
});
//# sourceMappingURL=count-input.js.map